module.exports = __webpack_public_path__ + "static/media/AccountProfileScreen.d9e52907.png";